import { getEventInfo } from 'api/eventpage';
import { eventCacheKey } from 'api/eventpage/cacheKeys';
import { useQuery } from 'react-query';

export const useEventQuery = (eventKey?: string, invitationId?: string, enabled = true) => {
  if (!eventKey) {
    throw Error('No event eventKey found!');
  }

  const { isFetching, data, isError } = useQuery(
    eventCacheKey(eventKey, invitationId),
    async () => await getEventInfo(eventKey, invitationId),
    {
      cacheTime: 1000 * 60 * 30,
      staleTime: 1000 * 60 * 30,
      enabled,
    },
  );

  return {
    isFetching,
    data,
    isError,
  };
};
